import { jsx as _jsx } from "react/jsx-runtime";
const React = require("react");
import menuLink from "./menuLink";
import footerTop from "./footerTop";
import homeJumbo, { largeJumbo } from "./jumbo";
import { customImageCrops } from "./imageCrops";
import { defaults } from "../shared/defaults";
import { pushNavigationEvent } from "./datalayer";
const logo = ()=>/*#__PURE__*/ _jsx("img", {
        width: "231",
        height: "83",
        src: "/bkw/images/rdam/logo.svg",
        alt: "Bibliotheek Rotterdam",
        "aria-hidden": "true"
    });
const rdam = {
    ...defaults,
    logo: logo,
    loginUrl: ()=>"https://rotterdam.hostedwise.nl/wise-apps/opac/branch/1000/my-account/",
    collectionSearchUrl: (term)=>`https://rotterdam.hostedwise.nl/wise-apps/opac/branch/1099/catalog/search?qs=${term}&scope=all`,
    menuLink: menuLink,
    onNavigationItemClick: (title)=>pushNavigationEvent(title),
    footerTop: footerTop,
    homeJumbo: homeJumbo,
    imageCrops: customImageCrops,
    genericLargeJumbo: largeJumbo
};
export default rdam;
